import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface CarbonSaleTransactionState {
    data: [] | null | any;
    currentPage: number | null;
    totalRecords: number | null;
    totalPages: number | null;
    allCarbonSaleTransaction: [] | null | any;
}

const initialState: CarbonSaleTransactionState = {
    data: null,
    totalRecords: null,
    totalPages: null,
    currentPage: null,
    allCarbonSaleTransaction: null,
};

export const carbonSaleTransactionSlice = createSlice({
    name: 'CarbonSaleTransaction',
    initialState,
    reducers: {
        setCarbonSaleTransaction: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
            state.currentPage = action.payload.data?.currentPage;
        },
        setCarbonSaleTransactionBySearch: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
            state.currentPage = action.payload.data?.currentPage;
        },
        setAllCarbonSaleTransaction: (state, action) => {
            state.allCarbonSaleTransaction = action.payload.data;
        },
        reset: (state) => {
            Object.assign(state, initialState);
        },
    },
});

export const { setCarbonSaleTransaction, setCarbonSaleTransactionBySearch, setAllCarbonSaleTransaction, reset } = carbonSaleTransactionSlice.actions;
export const getAllCarbonSaleTransactionDetails = (state: RootState) => state.carbonSaleTransaction.data;
export const getCarbonSaleTransactionTotalRecords = (state: RootState) => state.carbonSaleTransaction.totalRecords;
export const getAllCarbonSaleTransactionBySearch = (state: RootState) => state.carbonSaleTransaction.data;
export default carbonSaleTransactionSlice.reducer;
